import React from 'react';

const localImg = (name) => `/najdar-brand/${name}`;

const FullBleed = ({ children }) => (
  <div style={{
    marginLeft: 'calc(-1 * clamp(20px, 4vw, 40px))',
    marginRight: 'calc(-1 * clamp(20px, 4vw, 40px))',
    width: 'calc(100% + 2 * clamp(20px, 4vw, 40px))'
  }}>
    {children}
  </div>
);

const AllImages = () => {
  const images = [
    'najdar1.jpg',
    'Screenshot 2025-06-28 at 13.31.02.png',
    'najdar2.webp',
    'najdar4.webp',
    'najdar5.webp',
    'najdar6.webp',
    'najdar7.webp',
    'najdar8.webp',
    'najdar9.webp',
    'najdar10.gif',
    '11.jpg',
    'najdar11.webp',
    'najdar12.webp',
    'najdar13.webp',
    'Screenshot 2025-06-28 at 13.35.51.png',
    'najdar14.webp',
    'najdar15.webp',
    '18-wert.jpg',
    'najdar28.webp',
    '20-qq.jpg',
    '21-sdfg.jpg',
    '22-alone-in-line-najdar.webp',
    'najdar17.webp',
    '24-eiri.webp',
    '25-qwqw..webp',
    '26-qwqwq.webp',
    '27-djjd.webp',
    '28-wuwuw.webp',
    '29-hdhdh.webp',
    '30-eueue.webp',
    '31-wqwqw-.webp',
    '32-djdjd.webp',
    '33-eieie.webp',
    '34-djd..webp',
    '35-djd.webp',
    '36-dnd.webp',
    '37-eueu.webp'
  ];

  return (
    <FullBleed>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
        {images.map((name) => (
          <img
            key={name}
            src={localImg(name)}
            alt=""
            loading="lazy"
            style={{
              width: '100%',
              display: 'block',
              borderRadius: '0'
            }}
          />
        ))}
      </div>
    </FullBleed>
  );
};

export const najdarContent = {
  pageMaxWidth: '1400px',

  breadcrumb: {
    text: 'Back to Home',
    url: '/'
  },

  sections: [
    // HERO
    {
      id: 'hero',
      spacing: '0px',
      blocks: [
        {
          type: 'custom',
          render: () => (
            <div style={{
              padding: 'clamp(40px, 6vw, 80px) 0',
              textAlign: 'center'
            }}>
              <span style={{
                color: '#d4a276',
                fontSize: '12px',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '0.15em',
                display: 'block',
                marginBottom: '16px'
              }}>
                Fabric Boutique
              </span>
              <h1 style={{
                fontSize: 'clamp(2.5rem, 6vw, 5rem)',
                fontWeight: '300',
                color: 'var(--text-primary)',
                letterSpacing: '0.2em',
                textTransform: 'uppercase',
                margin: '0 0 20px 0'
              }}>
                NAJDAR
              </h1>
              <p style={{
                fontSize: 'clamp(0.95rem, 1.5vw, 1.1rem)',
                color: 'var(--text-secondary)',
                lineHeight: '1.7',
                maxWidth: '600px',
                margin: '0 auto'
              }}>
                Art direction and visual identity for a fine fabric boutique based in Jeddah, Saudi Arabia — branding, tone of voice, photography direction, packaging, and social media content.
              </p>
            </div>
          )
        }
      ]
    },

    // ALL IMAGES STACKED
    { id: 'images', spacing: '0px', blocks: [{ type: 'custom', render: () => <AllImages /> }] }
  ]
};